export type IntegrationDisconnectTransport = 'manual-api-key' | 'nango';

type IntegrationDisconnectRoutingOptions = {
    authType?: string;
    native?: boolean;
};

export const requiresConnectionScopedDisconnect = (provider: string): boolean => (
    provider.toLowerCase().replace(/[\s_]+/g, '-') === 'google-ads'
);

export const resolveFigmaDisconnectTransport = (
    options?: IntegrationDisconnectRoutingOptions,
): IntegrationDisconnectTransport => (
    String(options?.authType || '').trim().toLowerCase() === 'api_key'
    || options?.native === true
        ? 'manual-api-key'
        : 'nango'
);
